import { connect } from 'react-redux';
import { getCurrentUserId } from '../../../publicSession/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isCurrentUserOwner: ownProps.folder.owner &&
        getCurrentUserId(state) === ownProps.folder.owner.userId,
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=FolderCardContent.container.js.map